<template>
  <div class="layout">
    <div class="layout__header">
      <div class="layout__title">
        <h3>Clientes</h3>
      </div>
      <div class="layout__controls">
        <div class="form-inline">
          <button type="button" @click="consultar" class="btn-info">
            <i class="fa fa-search"></i><span>Consultar</span>
          </button>
          <button type="button" @click="exportarExcel" class="btn-success">
            <i class="fa fa-file-excel-o"></i><span>Exportar</span>
          </button>
        </div>
      </div>
    </div>
    <div class="card mb-2">
      <div class="card__content">
        <div class="row">
          <div class="col-xs-12 col-md-6">
            <div class="form-inline">
              <div class="form-inline__title">
                Fecha
              </div>
              <div class="form-inline__content">
                <label>
                  <input v-model="form.tipoFecha" type="radio" value="H" />
                  <span>Hoy</span>
                </label>
                <label>
                  <input v-model="form.tipoFecha" type="radio" value="A" />
                  <span>Ayer</span>
                </label>
                <label>
                  <input v-model="form.tipoFecha" type="radio" value="P" />
                  <span>Personalizado</span>
                </label>
                <div class="form-field" v-show="form.tipoFecha == 'P'">
                  <div class="datepicker-field datepicker-field--stretch">
                    <VueCtkDateTimePicker id="desde" v-model="form.fechaDesde" locale="es" only-date no-label
                      noClearButton button-now-translation="Ahora" format="YYYY-MM-DD" formatted="YYYY-MM-DD"
                      label="Seleccione fecha..." />
                    <label>Desde:</label>
                  </div>
                </div>
                <div class="form-field" v-show="form.tipoFecha == 'P'">
                  <div class="datepicker-field datepicker-field--stretch">
                    <VueCtkDateTimePicker id="hasta" v-model="form.fechaHasta" locale="es" only-date no-label
                      noClearButton button-now-translation="Ahora" format="YYYY-MM-DD" formatted="YYYY-MM-DD"
                      label="Seleccione fecha..." />
                    <label>Hasta:</label>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-xs-12 col-md-6">
            <div class="form-inline">
              <div class="form-inline__title">Estado del préstamo</div>
              <div class="form-inline__content">
                <label>
                  <input v-model="form.estado_prestamo" type="radio" value="A" />
                  <span>Pendientes</span>
                </label>
                <label>
                  <input v-model="form.estado_prestamo" type="radio" value="I" />
                  <span>Inactivos</span>
                </label>
                <label>
                  <input v-model="form.estado_prestamo" type="radio" value="P" />
                  <span>Pagados</span>
                </label>
                <label>
                  <input v-model="form.estado_prestamo" type="radio" value="T" />
                  <span>Todos</span>
                </label>
              </div>
            </div>
          </div>
          <div class="col-xs-12 col-md-6">
            <div class="form-field">
              <div class="multiselect-field">
                <multiselect @search-change="onSearchRutas" preserve-search placeholder="Busque y seleccione..."
                  selectedLabel="Seleccionado" selectLabel="Presiona enter para seleccionar"
                  deselectLabel="Presiona enter para eliminar" label="descripcion" track-by="descripcion" multiple
                  v-model="selectedRutas" :options="rutas" @input="inputRutas"></multiselect>
                <label for="rutas">Rutas</label>
              </div>
            </div>
          </div>
          <div class="col-xs-12 col-md-6">
            <div class="form-field">
              <input-field v-model="form.searchP" id="buscar" placeholder="Realice una consulta...">
                Consultar
              </input-field>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-xs-12">
        <k-table :createButton="false" :deleteButton="false" :editButton="false" :path="path" :params="form" :buscarButton="false" ref="listaClientes"
          :columns="columns"></k-table>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    puedeConsultar: {
      type: Boolean,
      required: true,
    }
  },
  data: function () {
    return {
      path: `${url}/clientes-ruta/consultar/C`,
      form: {
        estado_prestamo: "T",
        searchP: "",
        rutas_id: [],
        tipoFecha: "H",
        fechaDesde: moment(new Date()).format('YYYY-MM-DD'),
        fechaHasta: moment(new Date()).format('YYYY-MM-DD')
      },
      rutas: [],
      selectedRutas: [],
      columns: [
        {
          display: 'Identificación',
          value: 'numero_identificacion',
        },
        {
          display: 'Apellidos',
          value: 'apellidos_completos',
        },
        {
          display: 'Nombres',
          value: 'nombres_completos',
        },
        {
          display: 'Teléfonos',
          value: 'telefonos',
        },
        {
          display: 'Celulares',
          value: 'celulares',
        },
        {
          display: 'Dirección',
          value: 'direccion',
        },
        {
          display: 'Direcciones de cobro',
          value: 'direcciones_cobro',
        },
        {
          display: 'Creador',
          value: 'creador.nombre',
        },
        {
          display: 'Creación',
          value: 'created_at',
        }
      ]
    };
  },
  methods: {
    consultar: function () {
      this.$refs.listaClientes.loadRows();
    },
    exportarExcel: function () {
      let urlApi = `${url}/clientes-ruta/consultar/E${this.serialize(this.form)}`;
      window.open(urlApi, "_blank");
    },
    serialize: function (obj) {
      return (
        "?" +
        Object.keys(obj)
          .reduce(function (a, k) {
            let val = obj[k];
            let esArray = false;
            if (val instanceof Date) {
              val = val.toLocaleDateString("en");
            } else if (val instanceof Array) {
              esArray = true;
              let acumulador = "";
              for (let i = 0; i < val.length; i++) {
                acumulador += k + "%5B%5D=" + val[i];
                if (i != val.length - 1) {
                  acumulador += "&";
                }
              }
              val = acumulador;
              a.push(val);
            }
            if (!esArray) a.push(k + "=" + encodeURIComponent(val));
            return a;
          }, [])
          .join("&")
      );
    },
    onSearchRutas: function (search) {
      const that = this;
      const xmlhttp = new XMLHttpRequest();
      xmlhttp.onreadystatechange = function () {
        if (
          (this.readyState == 4 && this.status == 200) ||
          this.status == 201
        ) {
          const json = JSON.parse(this.responseText);
          that.rutas = json;
        }
      };
      const urlApi = `${url}/search/rutas?search=${search}`;
      xmlhttp.open("GET", urlApi, true);
      xmlhttp.send();
    },
    inputRutas: function () {
      this.form.rutas_id.splice(0, this.form.rutas_id.length);
      this.selectedRutas.forEach((element) => {
        this.form.rutas_id.push(element.id);
      });
    }
  },
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/forms/logistica/clientes/ListaClientesRuta.vue